// Meta Pixel + analytics helpers — safe no-op if fbq is not loaded
function fbq(...args) {
  if (typeof window !== "undefined" && window.fbq) {
    try { window.fbq(...args); } catch (_) { /* ignore */ }
  }
}

// Interest-list submit. Nothing is on sale, so there is no checkout event to
// fire — every conversion on this site is a lead.
export function trackInterestSubmit(city) {
  fbq("track", "Lead", { content_name: "Interest List Signup", content_category: "Antara Interest", content_type: city || "unspecified" });
  fbq("trackCustom", "InterestSubmit");
}

// Click through to the interest form (a lead intent, not a purchase)
// Form B (Host Antara; the pixel names below predate the rename and stay, so
// reporting continues unbroken) and Form C (sponsorship). A Lead each, told apart
// by content_name, plus a custom event per form for a Meta custom conversion.
const FORM_LABELS = {
  "private-event": ["Private Event Enquiry", "Antara Private Events", "PrivateEventSubmit"],
  sponsorship: ["Sponsorship Enquiry", "Antara Sponsorship", "SponsorshipSubmit"],
};
export function trackFormSubmit(form, params = {}) {
  const [name, category, custom] = FORM_LABELS[form] || [form, "Antara", "FormSubmit"];
  fbq("track", "Lead", { content_name: name, content_category: category, ...params });
  fbq("trackCustom", custom);
}

export function trackNotifyClick() {
  fbq("track", "Lead", { content_name: "Notify List Click", content_category: "Antara Notify" });
  fbq("trackCustom", "NotifyClick");
}

// Click through to BookMyShow. This is the purchase intent on the site, so it
// fires InitiateCheckout, not Lead. The purchase itself happens on BookMyShow,
// out of the pixel's sight, so this is the event the campaigns optimise for.
//
// The city rides along so Meta can tell the two shows apart: content_ids and
// content_name carry it for custom conversions built on InitiateCheckout, and
// TicketClick_Delhi / TicketClick_Chandigarh are there to target directly.
// placement says which button it was (hero, sticky, card, mid, final).
export function trackTicketClick(show, placement) {
  const city = show ? show.city : "unspecified";
  fbq("track", "InitiateCheckout", {
    content_name: `Bhaav Sangam ${city}`,
    content_category: "Antara Tickets",
    content_type: "product",
    content_ids: [show ? show.id : "unspecified"],
    num_items: 1,
    ...(show && show.priceFrom != null ? { value: show.priceFrom, currency: "INR" } : {}),
    city,
    placement: placement || "unspecified",
  });
  fbq("trackCustom", "TicketClick", { city, placement: placement || "unspecified" });
  if (show) fbq("trackCustom", `TicketClick_${city.replace(/\W+/g, "")}`, { placement: placement || "unspecified" });
}

export function trackWhatsAppClick() {
  fbq("track", "Contact", { content_name: "WhatsApp Click", content_category: "Antara Enquiry" });
  fbq("trackCustom", "WhatsAppClick");
}

export function trackSponsorClick() {
  fbq("track", "Lead", { content_name: "Sponsorship Page Click", content_category: "Antara Sponsorship" });
}

export function trackInstagramClick() {
  fbq("trackCustom", "InstagramClick");
}

// Open-call application. A performer applying is a lead, not a purchase — the
// showcase is unpaid, so nothing about this is a checkout. actType ("Solo" or
// "Group") rides along so the two can be told apart without a second event.
export function trackPerformSubmit(actType) {
  fbq("track", "Lead", { content_name: "Perform Application", content_category: "Antara Open Call", content_type: actType || "unspecified" });
  fbq("trackCustom", "PerformSubmit");
}

// Click through to the open call from anywhere on the site.
export function trackPerformClick() {
  fbq("trackCustom", "PerformClick");
}

// Reel viewer. ReelOpen when the full-screen viewer opens; ReelView each time
// a reel becomes the one playing (index is 1-based, as shown on screen).
export function trackReelOpen(index) {
  fbq("trackCustom", "ReelOpen", { reel: index + 1 });
}

export function trackReelView(index) {
  fbq("trackCustom", "ReelView", { reel: index + 1 });
}
